/* eslint-disable max-len */
import React from 'react';

import EmptyState from 'src/components/EmptyState';
import HttpLedger from 'src/components/HttpLedger';
import StepCell from 'src/components/cells/StepCell';
import EngagementNameCell from 'src/components/cells/EngagementNameCell';
import RelativeDate from 'src/components/RelativeDate';
import Card from 'src/components/Card';
import EngagementStatusCell from 'src/components/cells/EngagementStatusCell';

function EngagementsForWorkflowLedger({ workflowId }: { workflowId: string }) {
  const columns = [
    {
      title: 'Engagement',
      cellContent: (result: any) => <EngagementNameCell engagement={result} />,
    },
    {
      title: 'Step',
      cellContent: (result: any) => <StepCell stepName={result.stepName} />,
    },
    {
      title: 'Last activity',
      cellContent: (result: any) => <RelativeDate datetime={result.lastActivity} />,
    },
    {
      title: 'Status',
      cellContent: (result: any) => <EngagementStatusCell engagement={result} />,
    },
  ];

  return (
    <Card p={0} title="Engagements">
      <HttpLedger
        url={`/automatic/workflows/${workflowId}/engagements/`}
        columns={columns}
        emptyState={<EmptyState />}
        isPaginated
        isSearchable
      />
    </Card>
  );
}

export default EngagementsForWorkflowLedger;
